export default "__VITE_ASSET__5Y0nbLHM__"